module.exports = __webpack_public_path__ + "static/media/how_1xxhdpi.87f3e0f6.png";